// extracted by mini-css-extract-plugin
module.exports = {"card":"CardLanding_card__2Dgx_","points":"CardLanding_points__3FSmw","myPoints":"CardLanding_myPoints__2Z_i3","btn":"CardLanding_btn__3aFaH"};